<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamelist' }">{{ "竞技赛事" }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamedetail' }">{{ "赛事详情" }}</router-link>
          <span>></span>
          <span>{{ "参赛人员" }}</span>
        </div>
      </div>
    </div>
    <div class="main bgw" style="background-color: rgba(250, 250, 250, 1)">
      <div class="shop-container">
        <div class="tabs">
          <ul>
            <li @click="active = 1" :class="{ activeTab: active == 1 }">
              <a href="javascript:;">{{ "弓种" }}</a>
            </li>
            <li @click="active = 2" :class="{ activeTab: active == 2 }">
              <a href="javascript:;">{{ "团队" }}</a>
            </li>
          </ul>
        </div>
        <div class="card" v-for="item in allPerson" :key="item.id">
          <div class="card_body">
            <div class="card_tab"><i></i>{{ item.name+' '+'('+(item.userlist ? item.userlist.length+'人)' : '') }}</div>
            <div class="avatars">
              <div class="item" v-for="i in item.userlist" :key="i.id">
                <img :src="i.cover" mode="" />
                <div class="text">
                  {{ i.username }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        gameId:'',
      loading: false,
      active: 1,
      allPerson: [],
    };
  },
  mounted() {
    let gameId = this.$route.params.gameId;
    this.gameId = gameId;
    this.loading = true;
    this.init(this.active);
  },
  watch: {
    active(newV, oldV) {
      if (newV) {
        this.init(newV);
      }
    },
  },
  methods: {
    init(type) {
      this.$api
        .getInstitution({
          id: this.gameId,
          type: type,
        })
        .then((res) => {
          if (res.status) {
            if (res.data) {
              this.allPerson = res.data;
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .main {
    padding-top: 14px;
    .tabs {
      width: 100%;
      height: 52px;
      background: white;
      margin-bottom: 20px;

      ul {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        li {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          &.activeTab {
            color: rgba(231, 68, 47, 1);
          }
        }
      }
    }
    .card {
      padding: 26px 20px 23px;
      margin: 0 0 20px;
      background: #ffffff;
      .card_body {
        .card_tab {
          width: 100%;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(49, 44, 44, 1);
          line-height: 22px;
          margin-bottom: 27px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          i {
            width: 4px;
            height: 16px;
            display: inline-block;
            background-color: rgba(231, 68, 47, 1);
            margin-right: 8px;
          }
        }
        .avatars {
          display: grid;
          justify-content: space-between;
          align-items: center;
          grid-template-columns: repeat(8, 120px);

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 32px;
            &:nth-child(-n+8){
                margin-top: 0;
            }
            img {
              display: block;
              width: 120px;
              height: 120px;
              margin-bottom: 14px;
              box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
            }

            .text {
              width: 120px;
              height: 20px;
              line-height: 20px;
              font-size: 14px;
              text-align: center;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
